import { render, staticRenderFns } from "./msgtypeLink.vue?vue&type=template&id=203069dc&scoped=true&"
import script from "./msgtypeLink.vue?vue&type=script&lang=js&"
export * from "./msgtypeLink.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeLink.vue?vue&type=style&index=0&id=203069dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203069dc",
  null
  
)

export default component.exports